import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import AboutNavbar from "@/components/about/navbar";
import HistorySection from "@/components/about/history-section";
import VisionSection from "@/components/about/vision-section";
import MissionSection from "@/components/about/mission-section";
import AboutHeadingSection from "@/components/about/heading-section";
import ValuesSection from "@/components/about/values-section";
import OfficesSection from "@/components/about/offices-section";

const translationNamespaces = ["common", "nav", "about"];

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, translationNamespaces)),
    },
  };
};

const About = () => {
  const { t } = useTranslation();
  return (
    <div>
      <NextSeo
        title="About"
        description="AlHayat Foodstuff: Your Premier Partner for Quality Frozen Vegetables Worldwide"
        canonical="https://alhayatfoodstuff.com/about"
        openGraph={{
          title: "About",
          description:
            "AlHayat Foodstuff: Your Premier Partner for Quality Frozen Vegetables Worldwide",
        }}
      />
      <div className="h-12">
        <AboutNavbar />
      </div>
      <div className="flex flex-col">
        <AboutHeadingSection />
        <MissionSection />
        <HistorySection />
        <VisionSection />
        <ValuesSection />
        <OfficesSection />
      </div>
    </div>
  );
};

export default About;
